module.exports = __webpack_public_path__ + "static/prime-highlight-f9721949e52618e157b4c4719ff2e450.png";